import { render } from "./empresa-editar.vue?vue&type=template&id=538617e6"
import script from "./empresa-editar.vue?vue&type=script&lang=js"
export * from "./empresa-editar.vue?vue&type=script&lang=js"

import "./empresa-editar.vue?vue&type=style&index=0&id=538617e6&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__